import { useTranslation } from 'next-i18next';
import { Link } from 'theme-ui';
import { useRouter } from 'next/router';
import styles from '@features/footer/Footer.styles';
import theme from '@styles/theme';
import Icon from '@components/icons/Icon';
import { getLanguage } from '@utils/misc';
type PropsType = {
  chatLink: string;
  phoneNr: string;
};
const Contact = ({
  chatLink,
  phoneNr
}: PropsType) => {
  const {
    t
  } = useTranslation('layouts');
  const {
    locale
  } = useRouter();
  const lang = getLanguage(locale);
  const RenderContactChat = () => {
    switch (lang) {
      case 'pl':
        return typeof window !== 'undefined' && typeof window.LiveChatWidget !== 'undefined' && <>
              <div data-id="VeAR_qiV4Vl" className="livechat_button" dangerouslySetInnerHTML={{
            __html: `<a onclick="event.preventDefault(); if (LiveChatWidget !== undefined) { LiveChatWidget.call('maximize');return false; }" href="https://www.livechat.com/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_12811512">${t('footer.chat')}</a>`
          }} />
              <Icon color={theme.rawColors.darkGrey700} icon="Whatsapp" padding="0 0 0 18px" size="32px" title={t('footer.chat')} />
            </>;
      case 'en':
        return typeof window !== 'undefined' && typeof window.LiveChatWidget !== 'undefined' && <>
              <div data-id="eTweuIOZMQQ" className="livechat_button" dangerouslySetInnerHTML={{
            __html: `<a onclick="event.preventDefault(); if (LiveChatWidget !== undefined) { LiveChatWidget.call('maximize');return false; }" href="https://www.livechat.com/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_12811512">${t('footer.chat')}</a>`
          }} />
              <Icon color={theme.rawColors.darkGrey700} icon="Whatsapp" padding="0 0 0 18px" size="32px" title={t('footer.chat')} />
            </>;
      case 'es':
        return <Link href={chatLink} target="_blank" rel="noreferrer" title={`${t('footer.chat')} ${t('footer.links.opensInNewWindow')}`}>
            <span>{t('footer.chat')}</span>
            <Icon color={theme.rawColors.darkGrey700} icon="Whatsapp" size="32px" />
          </Link>;
      default:
        return null;
    }
  };
  return <div sx={styles.footerContact}>
      {phoneNr && <div>
          <div>{t('footer.contact')}</div>
          <a sx={styles.footerContactPhoneLink} href={`tel:${phoneNr}`}>
            {phoneNr}
          </a>
        </div>}
      <div sx={styles.chatContainer}>{RenderContactChat()}</div>
    </div>;
};
export default Contact;